import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridCellRenderer } from '../../abstraction/grid-cell-renderer';
import { SalesOrganization } from './sales-organization';

@Component({
  selector: 'soft-sales-organization-column',
  imports: [],
  template: `
      <span >{{ value()?.vkforg }}</span>
  `,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalesOrganizationColumnComponent<TRow extends object> extends GridCellRenderer<TRow, SalesOrganization>{

}
